// API Configuration
// Follows the same pattern as other BLH apps for consistency

export const API_URL = window.location.hostname.includes('localhost')
  ? 'http://localhost:3000'
  : 'https://server.brightlight.ai';

// MEET_URL was here, hardcoded to `https://www.meet.brightlight.ai`. Nothing
// imported it, and the value had been wrong since the app moved to
// meeting.brightlight.ai — an unused constant is exactly where a stale hostname
// survives, because nothing ever fails to point it out.
//
// This IS the meeting app, so its own address is `window.location.origin`,
// which is correct by construction on every environment.

// JaaS App ID - for Jitsi Meet
export const JAAS_APP_ID = 'vpaas-magic-cookie-42605b33872c49998a1a85b1ff35939c';